var f = Object.defineProperty;
var p = (e, t, s) => t in e ? f(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var u = (e, t, s) => p(e, typeof t != "symbol" ? t + "" : t, s);
import { jsx as d } from "react/jsx-runtime";
import { useContext as b, useCallback as o, useSyncExternalStore as w, createContext as y } from "react";
class A {
  constructor(t) {
    u(this, "features", {});
    u(this, "attributes", {});
    u(this, "listeners", /* @__PURE__ */ new Set());
    u(this, "snapshot", this.features);
    t && (this.attributes.url = t);
  }
  get url() {
    return this.attributes.url ?? "";
  }
  async init() {
    await this.refreshFeatures();
  }
  async refreshFeatures() {
    try {
      const t = await fetch(`${this.url}/api/features`);
      if (!t.ok)
        throw new Error("Failed to fetch features");
      const s = await t.json();
      this.features = s.features, this.updateSnapshot();
    } catch (t) {
      console.error(t);
    }
  }
  getFeatureValue(t, s) {
    const r = this.features[t];
    return r && r.defaultValue !== void 0 ? r.defaultValue : s;
  }
  getFeatures() {
    return this.features;
  }
  setAttributes(t) {
    this.attributes = { ...this.attributes, ...t };
  }
  getAttributes() {
    return this.attributes;
  }
  async setPayload(t) {
    this.features = t.features, this.updateSnapshot();
  }
  subscribe(t) {
    return this.listeners.add(t), () => {
      this.listeners.delete(t);
    };
  }
  getSnapshot() {
    return this.snapshot;
  }
  async getCoinPrice(t) {
    return this.request(`coin-price/${t}`);
  }
  async getMonitorNetwork(t) {
    return this.request("monitor-network", { project: t });
  }
  async getProductAnalyticsConfig() {
    return this.request("product-analytics");
  }
  async checkRestricted() {
    return (await fetch(`${this.url}/api/restricted/`, {
      method: "POST",
      headers: { accept: "", "content-type": "application/json" },
      body: JSON.stringify({})
    })).status === 403;
  }
  async request(t, s, r) {
    const i = `${this.url}/${t}`, a = s && Object.keys(s).length > 0 ? `${i}?${new URLSearchParams(s)}` : i, n = await fetch(a, r);
    if (!n.ok)
      throw new Error("Unexpected response");
    return n.json();
  }
  updateSnapshot() {
    this.snapshot = { ...this.features }, this.listeners.forEach((t) => t());
  }
}
const c = y(null);
function F({ client: e, children: t }) {
  return /* @__PURE__ */ d(c.Provider, { value: e, children: t });
}
function g() {
  const e = b(c);
  if (!e)
    throw new Error("useAppsBackendClient must be used within an AppsBackendClientProvider");
  return e;
}
function h(e) {
  const t = g(), s = o((l) => t.subscribe(l), [t]), r = o(() => t.getSnapshot(), [t]), a = w(s, r)[e], n = (a == null ? void 0 : a.defaultValue) ?? null;
  return {
    value: n,
    on: !!n,
    off: !n
  };
}
function v(e, t) {
  const { value: s } = h(e);
  return s ?? t;
}
function x(e) {
  const { on: t } = h(e);
  return t;
}
export {
  A as AppsBackendClient,
  F as AppsBackendClientProvider,
  g as useAppsBackendClient,
  h as useFeature,
  x as useFeatureIsOn,
  v as useFeatureValue
};
//# sourceMappingURL=index.es.js.map
